import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoginService } from '@app/core/services/login/login.service';
// import { identifierModuleUrl } from '@angular/compiler';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {
  confirmemail !: string;
  confirmEmailToken: any;
  isSuccess !: boolean;
  isError!: boolean;
  constructor(private router: Router, private loaderService: LoaderService,
    private notification: NotificationService, private loginService: LoginService, private activatedRoute: ActivatedRoute) {
    this.router = router;
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {

      this.confirmemail = params['eid'];
      this.confirmEmailToken = params['tkn'];
      if (this.confirmemail && this.confirmEmailToken) {
        this.fn_confirmEmail();
      }
    });
  }
  fn_confirmEmail() {
    this.loaderService.show();
    this.loginService.confrimEmail(encodeURIComponent(this.confirmemail), encodeURIComponent(this.confirmEmailToken))
      .subscribe((res: any) => {
        if (res.StatusCode === 200) {         
          setTimeout(() => {
            if (res.Data.ResponseData.IsAlreadyConfirmed) {
              this.notification.info('Link has been expired.', 'Email');
              localStorage.clear();
               this.router.navigate(['']);
               this.loaderService.hide();
              } else if (res.Data.ResponseData.IsEndUser) {
                  this.isError = false;
                  this.isSuccess = true;
                  this.notification.success(res.Message, 'Email');
                  this.router.navigate(['/', res.Data.ResponseData.StoreUrl]);
                  this.loaderService.hide();
              } else if (res.Data.ResponseData.IsStoreAdmin) {
                  this.isSuccess = true;
                  this.isError = false;
                  this.notification.success(res.Message, 'Email');
                  localStorage.clear();
                  this.router.navigate(['']);
                  this.loaderService.hide();
            }
          }, 10000);
        } else {
          this.isSuccess = false;
          this.isError = true;
          this.loaderService.hide();
        }
      }, (err: any) => {
        this.isSuccess = false;
        this.isError = true;
        this.loaderService.hide();
      });
  }

}
